import React from 'react'

export default function HideNortonBadge() {
  return <style dangerouslySetInnerHTML={{ // nosemgrep
    __html: `
    #_GUARANTEE_SealSpan {
      visibility: hidden !important;
    }
    ._GUARANTEE_Kicker_Container {
      display: none !important;
    }
  `,
  }}/>
}
